import React from 'react'; 
import './Hours.css'; 
import './Home.css'; 
import 'aos/dist/aos.css'; 
import '../The-Gallery/Visit-Us/Visit-Us.css'; 

function VisitMandarin() {

    return (
        <div id="visit"> 
          <h1 className="sub">独特的艺术让我们与众不同</h1>   
          <h3 className="paragraph">
            在 American Dragon，我们相信质量比数量重要得多！我们展示的每件作品都旨在
            与众不同，拥有无法以相同口径重现的非凡差异。
          </h3> 
        </div>
    );
  }
  
  export default VisitMandarin; 